/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForDimensionPrecompute extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForDimensionPrecompute.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForDimensionPrecompute>): ProgressDetailsForDimensionPrecompute {
        let obj = Object.assign(new ProgressDetailsForDimensionPrecompute(), model);
        ProgressDetailsForDimensionPrecompute.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForDimensionPrecompute>): ProgressDetailsForDimensionPrecompute {
        if (!model) return null;
        return ProgressDetailsForDimensionPrecompute.newInstance(<ProgressDetailsForDimensionPrecompute> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForDimensionPrecompute) {
        if (!obj) return;

        models.ProgressDetailsForDimensionPrecompute.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForDimensionPrecompute): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForDimensionPrecompute.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.by_dimension) {
            for (let val of this.by_dimension) {
                models.DimensionPrecomputeStatusEntry.fixupPrototype(val);
            }
        }
    }

    /**
     * Per-dimension precompute status
     */
    by_dimension: Array<models.DimensionPrecomputeStatusEntry>;

}
